module.exports = __webpack_public_path__ + "docs/img/robot-left.418d93ab.png";